<template>
    <app-layout title="Nafacturatie">
        <template #header>
            <page-title title="Nafacturatie" />
        </template>

        <template #pageContent>
            <div class="">
                <TableSearch :tableId="'overview-post-invoices-' + status" :values="postInvoices" class="w-1/4" placeholder="Zoeken"/>
            </div>

            <Table :id="'overview-post-invoices-' + status" :values="postInvoices" class="mt-4">
                <thead>
                    <tr>
                        <Th id="request.reference">Referentie aanvraag</Th>
                        <Th id="status_request_trans">Status aanvraag</Th>
                        <Th id="reference">Referentie nafacturatie</Th>
                        <Th id="status_post_invoice_trans">Status nafacturatie</Th>
                        <Th :sort="false"></Th>
                    </tr>
                </thead>
                <tbody>
                <tr v-for="postInvoice in state.sortedValues['overview-post-invoices-' + status]" :key="postInvoice.id">
                    <Td>{{ postInvoice.request.reference }}</Td>
                    <Td>{{ postInvoice.status_request_trans }}</Td>
                    <Td>{{ postInvoice.reference }}</Td>
                    <Td>{{ postInvoice.status_post_invoice_trans }}</Td>
                    <Td>
                        <Button
                            htmlType="a"
                            buttonClass="show"
                            size="small"
                            title="Details"
                            :href="route('accountancy.post-invoices.post-invoice',  {'postInvoice': postInvoice.id})"
                        />
                        <Button
                            htmlType="a"
                            buttonClass="edit"
                            size="small"
                            title="Bewerken"
                            :href="route('accountancy.post-invoices.edit-post-invoice', { 'postInvoice': postInvoice.id })"
                        />
                    </Td>
                </tr>
                </tbody>
            </Table>
        </template>
    </app-layout>
</template>

<script>
import AppLayout from '@/Layouts/AppLayout.vue'
import PageTitle from '@/Components/PageTitle.vue'
import Table from '@/Components/Table.vue'
import Th from '@/Components/Th.vue'
import Td from '@/Components/Td.vue'
import Button from '@/Components/Button.vue'
import TableSearch from '@/Components/TableSearch.vue'

import store from '@/store'

export default {
    components: {
        AppLayout,
        PageTitle,
        Button,
        Table,
        Td,
        Th,
        TableSearch,
    },
    props: [
        'postInvoices',
        'status',
    ],
    setup (props){

        return {
            state: store.state,
            ...store,
        }
    },
}

</script>
